import { Stack, Text, Image, Icon, Actionable } from "@bookingcom/bui-react";
import { WorldIcon } from "@bookingcom/bui-assets-react/streamline";
import { t, useI18n } from "@bookingcom/lingojs-react";
import React from "react";
import { useSelector } from "react-redux";
import { FLY_ANYWHERE_MAP_INDEX_ENTRY_IMAGE_URL } from "../../../../constants.js";
import styles from "./FlyAnywhereMapBanner.module.css";
import useCreateUrl from "../../../../hooks/useCreateUrl.js";
import useUserAgent from "../../../../hooks/useUserAgent.js";
import { useLocation } from "react-router-dom";
import { getSearch } from "../../../../store/search/selectors.js";
import flights_web_cat_fly_anywhere_map_view_www from "../../../../utils/experiments/cat/flights_web_cat_fly_anywhere_map_view_www.js";
import flights_web_cat_fly_anywhere_map_view_mdot from "../../../../utils/experiments/cat/flights_web_cat_fly_anywhere_map_view_mdot.js";
import useFlyAnywhereC360Events from "../../../../hooks/c360/useFlyAnywhereC360Events.js";
const FlyAnywhereMapBanner = ({ variant = "default", onNavigate }) => {
    const i18n = useI18n();
    const { createUrlWithApiPrefix } = useCreateUrl();
    const { isMobile } = useUserAgent();
    const location = useLocation();
    const searchState = useSelector(getSearch);
    const trackFlyAnywhereC360 = useFlyAnywhereC360Events();
    const mapViewExp = isMobile ? flights_web_cat_fly_anywhere_map_view_mdot : flights_web_cat_fly_anywhere_map_view_www;
    const isInline = variant === "inline";
    const mapUrl = React.useMemo(() => {
        const params = new URLSearchParams(location.search);
        if (!params.has("from") || !params.has("to")) {
            const segment = searchState.searchSegments?.[0];
            if (segment) {
                params.set("from", segment.from[0]?.code || "");
                params.set("to", segment.to[0]?.code || "Anywhere");
                params.set("fromCountry", segment.from[0]?.country || "");
                params.set("toCountry", "Anywhere");
                params.set("fromLocationName", segment.from[0]?.name || "");
                if (segment.departureDate)
                    params.set("depart", segment.departureDate);
                if (segment.returnDate)
                    params.set("return", segment.returnDate);
            }
            params.set("type", searchState.type || "ROUNDTRIP");
            params.set("adults", searchState.adults?.toString() || "1");
            params.set("cabinClass", searchState.cabinClass || "ECONOMY");
            params.set("toCountryCode", "Anywhere");
        }
        params.set("flyAnywhereView", "map");
        return createUrlWithApiPrefix(`/fly-anywhere?${params.toString()}`);
    }, [location.search, searchState, createUrlWithApiPrefix]);
    const mapContent = (React.createElement("div", { className: isInline ? styles.mapImageContainerInline : styles.mapImageContainer },
        React.createElement(Image, { src: FLY_ANYWHERE_MAP_INDEX_ENTRY_IMAGE_URL, contentMode: "fill", borderRadius: isInline ? undefined : 200, width: "100%", height: isInline ? "100%" : 250, className: isInline ? styles.mapImageInline : styles.mapImage, alt: i18n.trans(t("flights_cat_exploreanywhere_mapview_cta")) }),
        React.createElement("span", { className: isMobile ? styles.exploreAnywhereButtonMobile : styles.exploreAnywhereButton, "aria-hidden": "true" },
            React.createElement(Icon, { svg: WorldIcon }),
            React.createElement(Text, { tagName: "span", variant: "strong_1" }, i18n.trans(t("flights_cat_exploreanywhere_mapview_cta"))))));
    return (React.createElement(Actionable, { href: mapUrl, className: isInline ? styles.bannerLinkInline : styles.bannerLink, onClick: (e) => {
            e.preventDefault();
            if (variant === "default") {
                mapViewExp.goals.indexBanner();
            }
            const segment = searchState.searchSegments?.[0];
            trackFlyAnywhereC360("click_FA_Map_index", {
                context: "index",
                inbound_destination: segment?.from?.[0]?.name || "",
                outbound_destination: "Anywhere",
                inbound_dates: segment?.departureDate || "",
                outbound_dates: segment?.returnDate || "",
                journey_type: searchState.type || "ROUNDTRIP",
                cabin_class: searchState.cabinClass || "ECONOMY",
                direct: searchState.isDirect,
                number_of_travellers: {
                    adults: searchState.adults || 1,
                    children: searchState.children?.length || 0
                }
            });
            if (onNavigate) {
                onNavigate();
            }
            else {
                window.location.assign(mapUrl);
            }
        }, attributes: { "aria-label": i18n.trans(t("flights_cat_exploreanywhere_mapview_cta")) } }, isInline ? (mapContent) : (React.createElement(Stack, { direction: "column", alignItems: "start", justifyContent: "start" },
        React.createElement(Stack.Item, { grow: true },
            React.createElement(Text, { variant: "headline_2", tagName: "h2" }, i18n.trans(t("flights_cat_exploreanywhere_mapview_title")))),
        mapContent))));
};
export default FlyAnywhereMapBanner;
